import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
} from '@nebular/auth';
// import { RegisterComponent } from './auth/register/register.component'
import { AuthGuard } from './shared/auth-guard.service';
import { OTPComponent } from './auth/otp/otp.component';
// import { changePasswordComponent } from "./auth/changePassword/changePassword.component";
// import { ForgotPasswordComponent } from './auth/Forgot-password/forgot-password.component'
// import { resetPasswordComponent } from './auth/Reset-password/reset-password.component';
// import { AdminOtpComponent } from './admin/admin-otp/admin-otp.component';
// import { InstituteRegisterComponent } from './auth/institute-register/institute-register.component';
// import { TotalCourseListComponent } from "./auth/totalcourselist/totalcourselist.component";
// import { RegisterComponent } from './auth/register/register.component';

const routes: Routes = [
  { 
    path: 'pages',
    canActivate: [AuthGuard], 
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren:() => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'scholarshipform',
    loadChildren:() => import('./scholarshipform/scholarshipform.module').then(m => m.ScholarshipFormModule),
  },
  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        component: NbLoginComponent,
      },
      {
        path: 'login',
        component: NbLoginComponent,
      },
      {
        path: 'register',
        loadChildren: () => import('./auth/register/register.module').then(m => m.RegisterModule),
      },
      {
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'request-password',
        loadChildren: () => import('./auth/Forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
      },
      {
        path: 'reset-password',
        loadChildren: () => import('./auth/Reset-password/reset-password.module').then(m => m.ResetPasswordModule),
      },
      {
        path: 'otp',
        component: OTPComponent,
      },
      {
        path: 'changePassword',
        loadChildren: () => import('./auth/changePassword/changePassword.module').then(m => m.ChangePasswordModule),
        // component: changePasswordComponent,
      },
      {
        path: 'adminOtp',
        loadChildren: () => import('./admin/admin-otp/admin-otp.module').then(m => m.AdminOtpModule),
      },
      {
        path: 'instituteRegister',
        loadChildren: () => import('./auth/institute-register/institute-register.module').then(m => m.InstituteRegisterModule),
      },
      {
        path:'totalcourselist',
        loadChildren: () => import('./auth/totalcourselist/totalcourselist.module').then(m => m.TotalCourseListModule),
      },
    ],
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
    useHash: true
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
